import { Link, useLocation } from "react-router-dom";

export const Footer = () => {
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;
  return (
    <footer className="mt-20 border-t border-[#D4AF37]/15 bg-[#0A0A0C]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <h3 className="font-serif text-2xl font-bold gold-text">SIRAKH CREATIONS</h3>
            <p className="mt-1 text-xs tracking-[0.25em] text-zinc-500">MUSIC • PEOPLE • MOMENTS • TOGETHER</p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-zinc-400">
              Curating premium live experiences. Unforgettable nights, legendary artists, and moments worth keeping.
            </p>
          </div>
          <div>
            <p className="caption mb-4">Explore</p>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li><Link to="/events" className="hover:text-[#E5C158]">Events</Link></li>
              <li><Link to="/past-events" className="hover:text-[#E5C158]">Past Events</Link></li>
              <li><Link to="/gallery" className="hover:text-[#E5C158]">Gallery</Link></li>
              <li><Link to="/download-ticket" className="hover:text-[#E5C158]">My Tickets</Link></li>
            </ul>
          </div>
          <div>
            <p className="caption mb-4">Company</p>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li><Link to="/about" className="hover:text-[#E5C158]">About</Link></li>
              <li><Link to="/founders" className="hover:text-[#E5C158]">Founders</Link></li>
              <li><Link to="/contact" className="hover:text-[#E5C158]">Contact</Link></li>
              <li><Link to="/privacy" className="hover:text-[#E5C158]">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-[#E5C158]">Terms</Link></li>
              <li><Link to="/refund" className="hover:text-[#E5C158]">Refund Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-[#2A2A32] pt-6 text-xs text-zinc-500 sm:flex-row">
          <p>© {new Date().getFullYear()} Sirakh Creations. All rights reserved.</p>
          <Link to="/admin/login" className="hover:text-[#E5C158]" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
};
